import { reduce } from "et3-type-guards";
import i18n from "../../../../../../constants/i18n";
import getCorePopUpStore from "../../../../../../stores/core/core-popup-store";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import { TAlbum } from "../../../../../../Types";
import Et3Image from "../../../../../../core/et3-Image";
import Et3CustomizedButton from "../../../../../../core/et3-button/Et3CustomizedButton";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";

type UserImageArrowsProps = {
  currentIndex: number;
  imageArray: TAlbum[];
  onNextPress: () => void;
  onPreviousPress: () => void;
  moreThanOnePicture: boolean;
};

const UserImageArrows = withLiteObserverAndTheme<UserImageArrowsProps>(
  (props) => {
    const {
      theme,
      currentIndex,
      imageArray,
      onNextPress,
      onPreviousPress,
      moreThanOnePicture
    } = props;
    const { colors, unitX } = theme;
    const userID = getUserAdvancedStore().currentUserId.get();
    const pictures = reduce(
      () => getUserAdvancedStore().userData.get(userID).pictures,
      []
    );

    return moreThanOnePicture ? (
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={200}
        height={50}
        fDirection="row"
        alignItems="center"
        justifyContent="space-between"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={true}
          width={140}
          height={40}
          fDirection="row"
          alignItems="center"
          justifyContent="center"
          color={colors.all.white}
          style={{
            border: `1px solid ${colors.all.lightGray}`,
            borderRadius: 20 * unitX
          }}
          onClick={() => {}}
        >
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={130}
            height={40}
            fDirection="row"
            alignItems="center"
            justifyContent="space-around"
            color={colors.all.transparent}
            style={{}}
            onClick={() => {}}
          >
            <Et3CustomizedButton
              alignItems="center"
              fDirection="row"
              color={colors.all.transparent}
              justifyContent="center"
              withShadow={false}
              width={25}
              height={40}
              isEnabled={true}
              style={{
                borderRight: `1px solid ${colors.all.gray}`
              }}
              onClick={() => {
                onPreviousPress();
              }}
            >
              <Et3Text
                fontFamily={"MEDIUM"}
                fontSize={25}
                text={"<"}
                isSpan={false}
                color={colors.all.bondiBlue}
                style={{}}
              />
            </Et3CustomizedButton>
            <Et3Text
              fontFamily={"LIGHT"}
              fontSize={20}
              text={`${currentIndex + 1}`}
              isSpan={false}
              color={colors.all.davysGrey}
              style={{}}
            />
            <Et3Text
              fontFamily={"LIGHT"}
              fontSize={20}
              text={`/`}
              isSpan={false}
              color={colors.all.davysGrey}
              style={{}}
            />
            <Et3Text
              fontFamily={"LIGHT"}
              fontSize={20}
              text={`${imageArray.length}`}
              isSpan={false}
              color={colors.all.davysGrey}
              style={{}}
            />
            <Et3CustomizedButton
              alignItems="center"
              fDirection="row"
              color={colors.all.transparent}
              justifyContent="center"
              withShadow={false}
              width={25}
              height={40}
              isEnabled={true}
              style={{
                borderLeft: `1px solid ${colors.all.gray}`
              }}
              onClick={() => {
                onNextPress();
              }}
            >
              <Et3Text
                fontFamily={"MEDIUM"}
                fontSize={25}
                text={">"}
                isSpan={false}
                color={colors.all.bondiBlue}
                style={{}}
              />
            </Et3CustomizedButton>
          </ET3Div>
        </ET3Div>
        {pictures.length > 0 ? (
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={40}
            height={40}
            fDirection="column"
            alignItems="center"
            justifyContent="center"
            color={colors.all.white}
            style={{ borderRadius: 7 * unitX }}
            onClick={() => {}}
          >
            <Et3Image
              type="LOCAL"
              alt={i18n.get("USER_ALBUM_PICTURES")}
              imageName={"mask"}
              size={25}
              onClick={() => getCorePopUpStore().openPicAlbumPopUp()}
              style={{
                cursor: "pointer"
              }}
            />
          </ET3Div>
        ) : null}
      </ET3Div>
    ) : null;
  }
);
export default UserImageArrows;
